"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _reactRedux = require("react-redux");
var _reduxForm = require("redux-form");
var _modalActions = require("../../../redux/actions/modalActions");
var _orderFormTypes = require("../../../constants/sendOrder/orderFormTypes");
var _orderEntryActions = require("../../../redux/actions/orderEntryActions");
var _snackbarActions = require("../../../redux/actions/snackbarActions");
var _level1Actions = require("../../../redux/actions/level1Actions");
var _level2Actions = require("../../../redux/actions/level2Actions");
var _instrumentActions = require("../../../redux/actions/instrumentActions");
var _ConfirmOrderModalComponent = _interopRequireDefault(require("./ConfirmOrderModalComponent"));
var _modalDecorator = _interopRequireDefault(require("../../../hocs/modalDecorator"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var streamingForm = 'StreamingForm';
var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    resetForm: function resetForm() {
      return dispatch((0, _reduxForm.reset)(streamingForm));
    },
    setInstrument: function setInstrument(payload) {
      dispatch((0, _instrumentActions.setInstrument)(payload.instrumentId));
      // resubscribe to level2
      dispatch((0, _level1Actions.subscribeToLevel1)(payload.instrumentId));
      dispatch((0, _level2Actions.subscribeToLevel2)(payload.instrumentId));
      localStorage.setItem('selectedInstrumentId', payload.instrumentId);
    },
    confirmReport: function confirmReport(payload) {
      dispatch((0, _orderEntryActions.placeOrder)(_orderFormTypes.orderFormTypes["default"], payload)).then(function (res) {
        if (res.result === false) {
          dispatch((0, _snackbarActions.showSnack)({
            id: 'placeOrderError',
            text: res.errormsg || res.detail,
            type: 'warning'
          }));
        }
      });
    }
  };
};
var container = (0, _reactRedux.connect)(null, mapDispatchToProps)(_ConfirmOrderModalComponent["default"]);
var _default = exports["default"] = (0, _modalDecorator["default"])({
  name: _modalActions.MODAL_TYPES.CONFIRM_ORDER_REPORT
})(container);